import { ColumnDef } from '@tanstack/react-table';

import { IPaginationTable } from '../table/common/interfaces/IPaginationTable';

import Table from '@/components/table/common/Table';
import { INotifications } from '@/interfaces/api/notifications/INotifications';

const NotificationsTable = ({
	notifications,
	paginationOption,
	columns,
}: {
	notifications: INotifications[];
	paginationOption: IPaginationTable;
	columns: ColumnDef<INotifications, any>[];
	refetch: () => void;
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;
}) => {
	return (
		<div className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md px-[2rem]">
			<h3 className="text-md leading-5 font-medium py-[2rem] w-full">
				Notifications
			</h3>
			<div className="flex items-center justify-between w-full mb-1">
				<div className="inter-small-semibold p-3 text-grey-50">
					{`Total Notifications: ${notifications.length}`}
				</div>
			</div>
			<Table<INotifications>
				collection={{
					data: notifications,
					itemCount: notifications.length,
					pageNumber: paginationOption.pageNumber,
					pageSize: paginationOption.pageSize,
					pageCount: paginationOption.pageCount,
				}}
				columns={columns}
				paginationSection={paginationOption}
				tableStyles={{
					tableBox: 'w-full overflow-y-auto h-fit',
					table: 'w-full',
				}}
			/>
		</div>
	);
};

export default NotificationsTable;
